import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import { FSF_logo } from 'assets/icons';
import { CircularProgress } from '@mui/material';
import history from 'store/history';

const AdminResetPassword = ({
  adminResetPassword,
  isResetPasswordRequesting,
  isPasswordReset,
}) => {
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [error, setError] = useState('');
  const isDetailsValid =
    email && oldPassword && newPassword && confirmNewPassword && !error;

  const handleConfirmPassword = e => {
    setConfirmNewPassword(e.target.value);
    validatePasswords(newPassword, e.target.value);
  };

  const validatePasswords = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      setError('Passwords do not match');
    } else {
      setError('');
    }
  };

  const handleGoBackClick = () => {
    history.push('/admin/login');
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (isDetailsValid) {
      const resetDetails = {
        email,
        oldPassword,
        newPassword,
      };
      adminResetPassword(resetDetails);
    }
  };

  useEffect(() => {
    if (isPasswordReset) {
      setEmail('');
      setOldPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    }
  }, [isPasswordReset]);

  return (
    <>
      <div className={`${styles.wrapper}`}>
        <div
          style={{ width: '400px', marginTop: '50px' }}
          className={`${styles.formWrapper}`}
        >
          <img alt="" src={FSF_logo} className={`${styles.logo}`} />
          <div className={styles.childrenDiv}>
            <form onSubmit={handleSubmit}>
              <div className={styles.login}>
                <input
                  type="text"
                  placeholder="Email Address"
                  className={styles.input}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Old Password"
                  className={styles.input}
                  value={oldPassword}
                  onChange={e => setOldPassword(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="New Password"
                  className={styles.input}
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Confirm New Password"
                  className={styles.input}
                  value={confirmNewPassword}
                  onChange={handleConfirmPassword}
                />
                {error && (
                  <div
                    style={{
                      color: 'red',
                      fontSize: '14px',
                      marginLeft: '15px',
                      marginTop: '-5px',
                    }}
                  >
                    {error}
                  </div>
                )}
                <div className={styles.buttonDiv}>
                  <div className={styles.buttonStyle}>
                    <button
                      className={
                        isResetPasswordRequesting || !isDetailsValid
                          ? styles.disabled
                          : styles.button
                      }
                      type="submit"
                      disabled={isResetPasswordRequesting || !isDetailsValid}
                    >
                      {isResetPasswordRequesting ? (
                        <CircularProgress
                          size={20}
                          style={{ color: '#FE5000', marginTop: '5px' }}
                        />
                      ) : (
                        'Reset Password'
                      )}
                    </button>
                    <button className={styles.backButton} onClick={handleGoBackClick}>
                      Back To Sign In
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminResetPassword;
